import * as React from 'react';
import PropTypes from 'prop-types';
import tokens from '../../Tokens/tokens';
const { colors, spacing } = tokens;

const IconCalendar = ({ title, titleId, ...props }) => {
    const sizeArray = Object.entries(spacing.icons);
    const colorArray = Object.entries(colors.icons);
    const sizeOptions = new Map(sizeArray);
    const displaySize = sizeOptions.get(props.size);
    const colorOptions = new Map(colorArray);
    const displayColor = colorOptions.get(props.color);
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 16 16'
            fill={props.color && displayColor}
            aria-hidden={!title}
            role={title ? 'img' : null}
            width={props.size && displaySize}
            height={props.size && displaySize}
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path d='M15 16H1a1 1 0 01-1-1V3a1 1 0 011-1h14a1 1 0 011 1v12a1 1 0 01-1 1zM2 14h12V4H2z' />
            <path d='M5 6a1 1 0 01-1-1V1a1 1 0 012 0v4a1 1 0 01-1 1zm6 0a1 1 0 01-1-1V1a1 1 0 012 0v4a1 1 0 01-1 1z' />
        </svg>
    );
};

IconCalendar.propTypes = {
    title: PropTypes.string,
    titleId: PropTypes.string,
    size: PropTypes.oneOf(['sm', 'md']),
    color: PropTypes.oneOf(['primaryBlue', 'secondaryBlue', 'darkGrey', 'white']),
};
IconCalendar.defaultProps = {
    size: 'sm',
    color: 'darkGrey',
    focusable: false,
};
export default IconCalendar;
